import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    Label,
} from "reactstrap";
import Select from "react-select";
import { getAllUsers, getAllProjects } from "../../services/ValitanApiService";
import { createProjectUserMapping } from './ProjectMappedUserService';
import { enqueueSnackbar } from "notistack";

const MapUserModal = ({ isOpen, toggle, onSuccess }) => {
    const [users, setUsers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [errors, setErrors] = useState({});
    const [isCurrent] = useState(false);


    useEffect(() => {
        if (isOpen) {
            loadUsers();
            loadProjects();
        }
    }, [isOpen]);

    const loadUsers = async () => {
        try {
            const res = await getAllUsers(0, 100);
            const userOptions = res.data.content.map((user) => ({
                value: user.id,
                label: `${user.first_name} ${user.last_name} (${user.email})`,
            }));
            setUsers(userOptions);
        } catch (err) {
            console.error("Failed to load users", err);
        }
    };

    const loadProjects = async () => {
        try {
            const res = await getAllProjects(0, 100);
            const apiData = res?.data?.data || res?.data;

            const projectOptions = apiData.content.map((project) => ({
                value: project.id,
                label: project.name,
            }));

            setProjects(projectOptions);
        } catch (err) {
            console.error("Failed to load projects", err);
        }
    };


    const validateForm = () => {
        const errors = {};
        if (!selectedUser) errors.user = "User is required";
        if (!selectedProject) errors.project = "Project is required";
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            await createProjectUserMapping(
                { preventDefault: () => { } }, // dummy event
                selectedUser.value,
                selectedProject.value,
                isCurrent, // ✅ added this
                onSuccess,
                toggle,
                setErrors
            );
        } catch (err) {
            enqueueSnackbar("Failed to map user", { variant: "error" });
        }
    };


    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
            <ModalHeader toggle={toggle}>Map User to Project</ModalHeader>
            <ModalBody>
                <form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label>Select User</Label>
                        <Select
                            value={selectedUser}
                            onChange={setSelectedUser}
                            options={users}
                            placeholder="Choose user"
                            className={errors.user ? "is-invalid" : ""}
                        />
                        {errors.user && (
                            <div className="invalid-feedback d-block">{errors.user}</div>
                        )}
                    </FormGroup>

                    <FormGroup>
                        <Label>Select Project</Label>
                        <Select
                            value={selectedProject}
                            onChange={setSelectedProject}
                            options={projects}
                            placeholder="Choose project"
                            className={errors.project ? "is-invalid" : ""}
                        />
                        {errors.project && (
                            <div className="invalid-feedback d-block">{errors.project}</div>
                        )}
                    </FormGroup>
                    
                    {/* <FormGroup check className="mt-3">
                        <Label check>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                checked={isCurrent}
                                onChange={(e) => setIsCurrent(e.target.checked)}
                            />{" "}
                            It is current
                        </Label>
                    </FormGroup> */}


                    <Button color="primary" type="submit" className="float-end">
                        Map User
                    </Button>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default MapUserModal;
